import { FC, memo } from 'react'

import { getRouteApi, useRouterState } from '@tanstack/react-router'
import { TableDataQa } from 'commons/types/enums'
import { Table } from 'ui/components'

import { SarTableProps } from './SarTableProps'
import { columns } from './columns'
import { FilterForm } from './components'

const routeApi = getRouteApi('/_app/bsa/sars/')

export const SarTable: FC<SarTableProps> = memo((props) => {
  const { onItemSelect, onDelete, chosenItems, onShowWarnings, data } = props

  const {
    items,
    form: { page, size },
    total
  } = data

  const routerState = useRouterState()
  const navigate = routeApi.useNavigate()

  return (
    <>
      <FilterForm data={data} />
      <Table
        dataQa={TableDataQa.BP_CTR_LIST}
        columns={columns({
          onItemSelect,
          chosenItems,
          isAllItemsChosen: chosenItems.length === items.length,
          onDelete,
          onShowWarnings
        })}
        dataSource={items.map((item) => ({ item }))}
        pagination={{
          page,
          size,
          onChange: (page: number, size: number) => {
            navigate({ to: '.', search: (prev) => ({ ...prev, page, size }), resetScroll: false })
          },
          total
        }}
        loading={routerState.status === 'pending'}
      />
    </>
  )
})
